<template>
  <BaseTableView :head="tableHead" list-view="lgAndUp">
    <ProjectTypeTableItem v-for="item in workProjectTypeGrid" :key="item.id" :item="item" />
  </BaseTableView>
</template>

<script>
import ProjectTypeTableItem from 'components/setting/projectType/ProjectTypeTableItem'
export default {
  name: 'ProjectTypeTable',
  props: ['workProjectTypeGrid'],
  components: { ProjectTypeTableItem },
  data() {
    return {}
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages['setting-project_type']['tables']['segment'],
        },
        {
          text: this.localStorage.translations.pages['setting-project_type']['tables'][
            'tip-proekta'
          ],
          sort: {
            name: 'name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {text: '', active: true},
      ]
    },
  },
  methods: {},
  watch: {},
}
</script>
